<template>
  <div v-if="start">
    <div class="lg:w-3/4">
      <vx-card class="lg:p-8 w-full mb-6">
        <div class="vx-card__title mb-4">
          <h4 class="mb-4">Добавление оператора</h4>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <vs-input
              class="w-full"
              label="Имя: *"
              name="firstName"
              v-model="firstName"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('firstName')">{{ errors.first('firstName') }}</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <vs-input
              class="w-full"
              label="Фамилия:"
              v-model="lastName"
            />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <vs-input
              class="w-full"
              label="E-mail: *"
              type="email"
              name="email"
              v-model="email"
              v-validate="'required|email'"
            />
            <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <password-input
              label="Пароль: *"
              name="password"
              v-model="password"
              v-validate="'required|min:8'"
              ref="password"
              class="w-full" />
            <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <password-input
              label="Подтвердить пароль:"
              name="password_confirmation"
              v-model="password_confirmation"
              data-vv-as="password"
              v-validate="'confirmed:password'"
              class="w-full" />
            <span class="text-danger text-sm" v-show="errors.has('password_confirmation')">{{ errors.first('password_confirmation') }}</span>
          </div>
        </div>
        <UploadFile
          v-model="profileImageKey"
        />
        <div class="flex justify-end mt-6">
          <vs-button
            ref="loadableButton"
            id="button-with-loading"
            class="vs-con-loading__container"
            @click.prevent="submitAdd">
            Добавить
          </vs-button>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import Operators from '../../api/http/models/Operators'
import UploadFile from '../../components/UploadFile'
import errorsParsing from '../../mixins/errorsParsing'

import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      start: false,
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      password_confirmation: '',
      profileImageKey: ''
    }
  },
  computed: {
    ...mapGetters(['authUserCompany']),
    name () {
      return this.lastName ? `${this.firstName} ${this.lastName}` : this.firstName
    }
  },
  mixins: [errorsParsing],
  components: {
    UploadFile
  },
  methods: {
    async submitAdd () {
      const validate = await this.$validator.validateAll()

      if (validate) {
        this.$vs.loading({
          background: 'primary',
          color: '#fff',
          container: '#button-with-loading',
          scale: 0.45
        })

        const response = await Operators.addOne(this.authUserCompany.slug, {
          name: this.name,
          email: this.email,
          password: this.password,
          profile_image_key: this.profileImageKey
        })

        this.$vs.loading.close('#button-with-loading > .con-vs-loading')
        if (response.errors) {
          this.errorsParsing(response.errors)
        } else if (response.status === 'success') {
          this.$router.push({ name: 'operators' })
        }
      }
    }
  },
  created () {
    this.start = true
  }
}
</script>
